export default __webpack_public_path__ + "static/media/ILPlatform_Books.91690615.webp";